<template>
  <help-info-wrapper :service-name="serviceName" class="warp">
    <template>
      <div class="pa-4">
        <v-progress-linear
          indeterminate
          color="teal"
          v-if="loading"
          class="my-2"
        ></v-progress-linear>
        <div>
          <v-col
            v-for="(item, i) in floorNameHok?.floors"
            :key="i"
            style="padding: 0.5rem; width: 100%; cursor: pointer"
          >
            <v-card rounded="xl">
              <v-list-item>
                <v-list-item-avatar
                  @click="
                    addFloors = true;
                    tab = i;
                  "
                >
                  <img
                    style="
                      border-radius: 100%;
                      width: 35px;
                      height: 35px;
                      margin-left: 5px;
                    "
                    v-if="item.image"
                    rounded
                    :src="item.image"
                  />
                  <v-icon size="30" v-else class="grey lighten-1" dark>
                    mdi-format-line-spacing
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content
                  @click="
                    addFloors = true;
                    tab = i;
                  "
                >
                  <v-list-item-title></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="item.name"
                  ></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <div>
                    <v-btn
                      icon
                      @click="
                        addFloors = true;
                        tab = i;
                      "
                    >
                      <v-icon color="gray">mdi-store-edit</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteFloor(i + 1, item.name)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </v-col>
          <div class="rowinfo mt-3">
            <v-btn
              outlined
              @click="addShop = true"
              color="success"
              class="contentinfo"
              :disabled="loading"
            >
              <v-icon size="20">mdi-plus</v-icon>
              افزودن فروشگاه
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-shop-lg`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن فروشگاه"
            />
          </div>
        </div>

        <!-- اضافه کردن طبقه -->
        <custom-popup
          v-model="addShop"
          :cons="{ title: ' افزودن فروشگاه ' }"
          maxWidth="640"
          @action="setFloor"
        >
          <div class="pa-4">
            <custom-tabs v-model="tabs" grow>
              <template v-slot:staticTabs>
                <v-tab
                  ><span
                    class="d-flex row"
                    style="justify-content: start; align-items: center"
                  >
                    اضافه کردن طبقات
                    <help-info
                      :element-name="`${serviceName}-${componentName}-add-roof`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="اضافه کردن طبقات"
                    />
                  </span>
                </v-tab>
              </template>
              <template v-slot:middle>
                <div class="py-2" />
              </template>
              <template v-slot:staticItems>
                <v-tab-item>
                  <div class="w-fill py-2">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="floorName"
                        append-icon="mdi-web"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        class="contentinfo"
                        :rules="[
                          (v) =>
                            v.length > 3 ||
                            'مقدار شما باید بیشتر از ۳ کاراکتر باشد',
                        ]"
                        counter="50"
                        dense
                        hint="لطفا طبقه مجتمع خود را وارد کنید."
                        label="طبقه"
                        maxLength="50"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-roof`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="طبقه"
                      />
                    </div>
                    <pic-selector
                      :edit-img="false"
                      :edit-name="false"
                      :field.sync="picture"
                      default-cat-name="دسته‌بندی‌ها"
                      one-pic
                      single
                    />
                  </div>
                </v-tab-item>
              </template>
            </custom-tabs>
          </div>
        </custom-popup>

        <!-- ویرایش طبقات -->
        <custom-popup
          v-model="addFloors"
          :cons="{ title: ' افزودن / ویرایش طبقات' }"
          maxWidth="1024"
          maxHeigth=""
          @action=""
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-edit-roof`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="افزودن/ ویرایش طبقات"
            />
          </template>
          <v-card
            :disabled="loading"
            :style="{ opacity: loading ? '0.5' : '1' }"
          >
            <v-col cols="12" class="">
              <!-- تب‌های طبقات -->
              <v-tabs dir="rtl" v-model="tab" color="green">
                <v-tab
                  v-for="item in floorNameHok?.floors"
                  @click="idFloor = item.id"
                  :key="item.id"
                >
                  <div class="flex align-items">
                    <v-icon class="mx-1" v-if="!item.image">mdi-stairs</v-icon>
                    <img
                      style="
                        border-radius: 100%;
                        width: 35px;
                        height: 35px;
                        margin-left: 5px;
                      "
                      v-else
                      rounded
                      :src="item.image"
                    />
                    {{ item.name }}
                  </div>
                </v-tab>
              </v-tabs>
              <!-- نمایش محتوای تب‌ها -->
              <v-tabs-items v-model="tab" color="green">
                <v-tab-item v-for="(item, i) in floorNameHok?.floors" :key="i">
                  <v-card flat>
                    <!-- تب‌های لاین -->
                    <div style="display: flex; align-items: center">
                      <v-btn
                        @click="
                          addLineName = true;
                          idFloor = item.id;
                        "
                        color="primary"
                        class="mr-3"
                        fab
                        dark
                        small
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>

                      <v-tabs
                        color="green"
                        dir="rtl"
                        v-model="tab2"
                        height="5rem"
                      >
                        <v-tab
                          v-for="(itemI, i) in item.items"
                          :key="i"
                          @click="idLine = itemI.id"
                        >
                          <img
                            style="
                              border-radius: 100%;
                              width: 35px;
                              height: 35px;
                              margin-left: 5px;
                            "
                            v-if="itemI.image"
                            rounded
                            :src="itemI.image"
                          />
                          <v-icon v-else class="mx-1">mdi-layers</v-icon>
                          {{ itemI.name }}
                          <v-icon
                            @click="deleteLine(item.id, itemI.id, itemI.name)"
                            class="mx-2"
                            >mdi-delete</v-icon
                          >
                        </v-tab>
                      </v-tabs>
                    </div>

                    <!-- نمایش فروشگاه‌ها -->
                    <v-tabs-items v-model="tab2" :key="renderKey">
                      <!-- فروشگاه‌های لاین -->
                      <v-tab-item v-for="(base, i) in item.items" :key="i">
                        <v-card flat>
                          <custom-tabs v-model="tabsPop" grow>
                            <template v-slot:staticTabs>
                              <v-tab :ripple="false">
                                <div
                                  class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                                  style="
                                    justify-content: center !important;
                                    align-items: center;
                                  "
                                >
                                  <div class="cornel-left" />
                                  <div class="cornel-right" />
                                  <v-icon class="me-2">mdi-plus</v-icon>
                                  فروشگاه‌ها
                                  <help-info
                                    :element-name="`${serviceName}-${componentName}-shops-tab`"
                                    :service-name="serviceName"
                                    :help-data="helpData"
                                    class="buttoninfo"
                                    label="فروشگاه‌ها"
                                  />
                                </div>
                              </v-tab>
                              <v-tab :ripple="false">
                                <div
                                  class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                                  style="
                                    justify-content: center !important;
                                    align-items: center;
                                  "
                                >
                                  <div class="cornel-left" />
                                  <div class="cornel-right" />
                                  ویرایش طبقه
                                  <help-info
                                    :element-name="`${serviceName}-${componentName}-edit-roof-tab`"
                                    :service-name="serviceName"
                                    :help-data="helpData"
                                    class="buttoninfo"
                                    label="ویرایش طبقه"
                                  />
                                </div>
                              </v-tab>
                            </template>
                            <template v-slot:middle>
                              <div class="py-2" />
                            </template>
                            <template v-slot:staticItems>
                              <v-tab-item>
                                <div
                                  class="d-flex"
                                  style="flex-direction: column"
                                >
                                  <v-progress-linear
                                    indeterminate
                                    color="teal"
                                    v-if="loading"
                                    class="my-2"
                                  ></v-progress-linear>
                                  <div class="rowinfo">
                                    <v-btn
                                      class="contentinfo"
                                      elevation="2"
                                      @click="
                                        idFloor = item.id;
                                        idLine = base.id;
                                        addShops = true;
                                      "
                                      color="success"
                                    >
                                      <v-icon class="mx-1">mdi-plus</v-icon>
                                      افزودن فروشگاه جدید
                                    </v-btn>
                                    <help-info
                                      :element-name="`${serviceName}-${componentName}-addShops-roof`"
                                      :service-name="serviceName"
                                      :help-data="helpData"
                                      class="buttoninfo"
                                      label="افزودن فروشگاه جدید"
                                    />
                                  </div>
                                  <v-divider vertical class="py-2"></v-divider>
                                  <v-row class="my-3 mx-1">
                                    <v-col
                                      v-for="shop in base.shops"
                                      :key="shop.id"
                                      cols="12"
                                      md="6"
                                      lg="3"
                                    >
                                      <v-card
                                        class="mx-auto"
                                        rounded="xl"
                                        max-width="400"
                                      >
                                        <v-img
                                          class="white--text align-end"
                                          height="200px"
                                          :src="
                                            floorNameHok?.shops?.find(
                                              (item) =>
                                                item.qr_id === shop.qr_id,
                                            )?.images[0].url || null
                                          "
                                          alt="banner"
                                        >
                                          <v-card-text
                                            class=""
                                            style="
                                              display: flex;
                                              flex-direction: column;
                                              justify-content: center;
                                              align-items: center;
                                              padding: 0;
                                              background: #0000009c;
                                            "
                                          >
                                            <v-card-title size="25">
                                              {{
                                                floorNameHok?.shops?.find(
                                                  (item) =>
                                                    item.qr_id === shop.qr_id,
                                                )?.title
                                              }}
                                            </v-card-title>
                                            <v-card-subtitle>
                                              {{
                                                floorNameHok?.shops?.find(
                                                  (item) =>
                                                    item.qr_id === shop.qr_id,
                                                )?.subtitle
                                              }}
                                            </v-card-subtitle>
                                          </v-card-text>
                                        </v-img>

                                        <v-card-text style="padding: 0">
                                          <v-card-title>
                                            نام فروشگاه :
                                            {{
                                              floorNameHok?.shops?.find(
                                                (item) =>
                                                  item.qr_id === shop.qr_id,
                                              )?.setting.organizationName
                                            }}
                                          </v-card-title>
                                          <v-card-subtitle>
                                            ادرس کیوآر :
                                            {{
                                              floorNameHok?.shops?.find(
                                                (item) =>
                                                  item.qr_id === shop.qr_id,
                                              )?.setting.name
                                            }}
                                          </v-card-subtitle>
                                        </v-card-text>
                                        <v-card-actions>
                                          <v-btn
                                            @click="
                                              editShop = true;
                                              dtUrl = shop?.url;
                                              editShopId = shop?.qr_id;
                                            "
                                            color="orange"
                                            text
                                          >
                                            ویرایش
                                          </v-btn>
                                          <v-btn
                                            @click="
                                              deleteShop(
                                                item.id,
                                                base.id,
                                                shop.id,
                                                shop.data?.title,
                                                shop?.qr_id,
                                              )
                                            "
                                            color="orange"
                                            text
                                          >
                                            حذف کردن
                                          </v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-tab-item>
                              <v-tab-item>
                                <div class="pa-2">
                                  <h3 class="my-3">ویرایش طبقه</h3>
                                  <v-col cols="6">
                                    <div class="rowinfo">
                                      <v-text-field
                                        v-model="item.name"
                                        append-icon="mdi-pencil"
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        class="contentinfo"
                                        :rules="[
                                          (v) =>
                                            v.length > 3 ||
                                            'مقدار شما باید بیشتر از ۳ کاراکتر باشد',
                                        ]"
                                        counter="50"
                                        dense
                                        hint="لطفا نام طبقه خود را وارد کنید."
                                        label="ویرایش"
                                        maxLength="50"
                                        outlined
                                      />
                                      <help-info
                                        :element-name="`${serviceName}-${componentName}-item-name-edit`"
                                        :service-name="serviceName"
                                        :help-data="helpData"
                                        class="buttoninfo"
                                        label="ویرایش"
                                      />
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <pic-selector
                                      :edit-img="false"
                                      :edit-name="false"
                                      :field.sync="item.image"
                                      default-cat-name="دسته‌بندی‌ها"
                                      one-pic
                                      single
                                    />
                                  </v-col>
                                </div>
                                <div v-if="item.items.length > 0">
                                  <h3 class="my-3">ویرایش لاین</h3>
                                  <v-col cols="6">
                                    <div class="rowinfo">
                                      <v-text-field
                                        v-model="base.name"
                                        append-icon="mdi-pencil"
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        :rules="[
                                          (v) =>
                                            v.length > 3 ||
                                            'مقدار شما باید بیشتر از ۳ کاراکتر باشد',
                                        ]"
                                        counter="50"
                                        dense
                                        hint="لطفا نام لاین خود را وارد کنید."
                                        label="ویرایش"
                                        maxLength="50"
                                        outlined
                                        class="contentinfo"
                                      />
                                      <help-info
                                        :element-name="`${serviceName}-${componentName}-base-name-edit`"
                                        :service-name="serviceName"
                                        :help-data="helpData"
                                        class="buttoninfo"
                                        label="ویرایش"
                                      />
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <pic-selector
                                      :edit-img="false"
                                      :edit-name="false"
                                      :field.sync="base.image"
                                      default-cat-name="دسته‌بندی‌ها"
                                      one-pic
                                      single
                                    />
                                  </v-col>
                                </div>
                              </v-tab-item>
                            </template>
                          </custom-tabs>
                        </v-card>
                      </v-tab-item>
                      <!-- فروشگاه‌های مستقیم طبقه -->
                      <v-tab-item v-if="item.items.length === 0">
                        <v-card flat>
                          <custom-tabs v-model="tabsPop" grow>
                            <template v-slot:staticTabs>
                              <v-tab :ripple="false">
                                <div
                                  class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                                  style="
                                    justify-content: center !important;
                                    align-items: center;
                                  "
                                >
                                  <div class="cornel-left" />
                                  <div class="cornel-right" />
                                  <v-icon class="me-2">mdi-plus</v-icon>
                                  فروشگاه‌ها
                                  <help-info
                                    :element-name="`${serviceName}-${componentName}-shops-tab2`"
                                    :service-name="serviceName"
                                    :help-data="helpData"
                                    class="buttoninfo"
                                    label="فروشگاه‌ها"
                                  />
                                </div>
                              </v-tab>
                              <v-tab :ripple="false">
                                <div
                                  class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                                  style="
                                    justify-content: center !important;
                                    align-items: center;
                                  "
                                >
                                  <div class="cornel-left" />
                                  <div class="cornel-right" />
                                  ویرایش طبقه
                                  <help-info
                                    :element-name="`${serviceName}-${componentName}-edit-roof-tab2`"
                                    :service-name="serviceName"
                                    :help-data="helpData"
                                    class="buttoninfo"
                                    label="ویرایش طبقه"
                                  />
                                </div>
                              </v-tab>
                            </template>
                            <template v-slot:middle>
                              <div class="py-2" />
                            </template>
                            <template v-slot:staticItems>
                              <v-tab-item>
                                <div
                                  class="d-flex"
                                  style="flex-direction: column"
                                >
                                  <v-progress-linear
                                    indeterminate
                                    color="teal"
                                    v-if="loading"
                                    class="my-2"
                                  ></v-progress-linear>
                                  <v-btn
                                    width="180"
                                    elevation="2"
                                    @click="
                                      idFloor = item.id;
                                      idLine = null;
                                      addShops = true;
                                    "
                                    color="success"
                                  >
                                    <v-icon class="mx-1">mdi-plus</v-icon>
                                    افزودن فروشگاه جدید
                                  </v-btn>
                                  <v-divider vertical class="py-2"></v-divider>
                                  <v-row class="my-3 mx-1">
                                    <v-col
                                      v-for="shop in item.shops"
                                      :key="shop.id"
                                      cols="12"
                                      md="6"
                                      lg="3"
                                    >
                                      <v-card
                                        class="mx-auto"
                                        rounded="xl"
                                        max-width="400"
                                      >
                                        <v-img
                                          class="white--text align-end"
                                          height="200px"
                                          :src="
                                            floorNameHok?.shops?.find(
                                              (item) =>
                                                item.qr_id === shop.qr_id,
                                            )?.images[0].url || null
                                          "
                                          alt="banner"
                                        >
                                          <v-card-text
                                            class=""
                                            style="
                                              display: flex;
                                              flex-direction: column;
                                              justify-content: center;
                                              align-items: center;
                                              padding: 0;
                                              background: #0000009c;
                                            "
                                          >
                                            <v-card-title size="20"
                                              >{{
                                                floorNameHok?.shops?.find(
                                                  (item) =>
                                                    item.qr_id === shop.qr_id,
                                                )?.title
                                              }}
                                            </v-card-title>
                                            <v-card-subtitle>
                                              {{
                                                floorNameHok?.shops?.find(
                                                  (item) =>
                                                    item.qr_id === shop.qr_id,
                                                )?.subtitle
                                              }}
                                            </v-card-subtitle>
                                          </v-card-text>
                                        </v-img>

                                        <v-card-text style="padding: 0">
                                          <v-card-title>
                                            نام فروشگاه :
                                            {{
                                              floorNameHok?.shops?.find(
                                                (item) =>
                                                  item.qr_id === shop.qr_id,
                                              )?.setting.organizationName
                                            }}
                                          </v-card-title>
                                          <v-card-subtitle>
                                            ادرس کیو آر :
                                            {{
                                              floorNameHok?.shops?.find(
                                                (item) =>
                                                  item.qr_id === shop.qr_id,
                                              )?.setting.name
                                            }}
                                          </v-card-subtitle>
                                        </v-card-text>

                                        <v-card-actions>
                                          <v-btn
                                            @click="
                                              editShop = true;
                                              editShopId = shop?.qr_id;
                                              dtUrl = shop?.url;
                                            "
                                            color="orange"
                                            text
                                          >
                                            ویرایش
                                          </v-btn>
                                          <v-btn
                                            @click="
                                              deleteShopFromFloor(
                                                item.id,
                                                shop.id,
                                                shop.data?.title,
                                                shop?.qr_id,
                                              )
                                            "
                                            color="orange"
                                            text
                                          >
                                            حذف کردن
                                          </v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-tab-item>
                              <v-tab-item>
                                <div class="pa-2">
                                  <h3 class="my-3">ویرایش طبقه</h3>
                                  <v-col cols="6">
                                    <v-text-field
                                      v-model="item.name"
                                      append-icon="mdi-pencil"
                                      clear-icon="mdi-close-circle-outline"
                                      clearable
                                      :rules="[
                                        (v) =>
                                          v.length > 3 ||
                                          'مقدار شما باید بیشتر از ۳ کاراکتر باشد',
                                      ]"
                                      counter="50"
                                      dense
                                      hint="لطفا نام طبقه خود را وارد کنید."
                                      label="ویرایش"
                                      maxLength="50"
                                      outlined
                                    />
                                  </v-col>
                                  <v-col>
                                    <pic-selector
                                      :edit-img="false"
                                      :edit-name="false"
                                      :field.sync="item.image"
                                      default-cat-name="دسته‌بندی‌ها"
                                      one-pic
                                      single
                                    />
                                  </v-col>
                                </div>
                              </v-tab-item>
                            </template>
                          </custom-tabs>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-card>
        </custom-popup>

        <!-- اضافه کردن لاین -->
        <custom-popup
          @action="setLine"
          v-model="addLineName"
          :cons="{ title: ' افزودن لاین جدید ' }"
        >
          <div class="pa-4">
            <custom-tabs v-model="tabs" grow>
              <template v-slot:staticTabs>
                <v-tab> افزودن لاین جدید </v-tab>
              </template>
              <template v-slot:middle>
                <div class="py-2" />
              </template>
              <template v-slot:staticItems>
                <v-tab-item>
                  <div class="w-fill py-2">
                    <v-text-field
                      v-model="lineName"
                      append-icon="mdi-web"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      :rules="[
                        (v) =>
                          v.length > 3 ||
                          'مقدار شما باید بیشتر از ۳ کاراکتر باشد',
                      ]"
                      counter="50"
                      dense
                      hint="لطفا لاین طبقه خود را وارد کنید."
                      label="لاین"
                      maxLength="50"
                      outlined
                    />
                    <pic-selector
                      :edit-img="false"
                      :edit-name="false"
                      :field.sync="picture"
                      default-cat-name="دسته‌بندی‌ها"
                      one-pic
                      single
                    />
                  </div>
                </v-tab-item>
              </template>
            </custom-tabs>
          </div>
        </custom-popup>

        <!-- اضافه کردن فروشگاه -->
        <custom-popup
          v-model="addShops"
          @action="addShopLineWithModal"
          hideConfirm
          :cons="{ title: ' ثبت فروشگاه ' }"
        >
          <div class="pa-2">
            <br />
            <QrTextField v-model="dtUrl" @click="addShopLine" />
          </div>
        </custom-popup>
        <!-- Edite Shop -->
        <custom-popup
          v-model="editShop"
          :cons="{ title: ' ویراش فروشگاه ' }"
          maxWidth="640"
          hideConfirm
        >
          <QrTextField
            v-model="dtUrl"
            @click="editShopLine"
            :editShopValue.sync="editShopValue"
            edit
          />
        </custom-popup>
      </div>
    </template>
  </help-info-wrapper>
</template>
<script>
import Vue from "vue";
import PicSelector from "../UploadCenter/picSelector.vue";
import QrTextField from "../floor/qrTextField.vue";
import { Bus } from "@/main";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
  components: { PicSelector, QrTextField },
  props: {
    value: [Object, Array],
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "Floor",

      addShop: false,
      addFloors: false,
      addLineName: false,
      addShops: false,
      editShop: false,
      tabs: 1,
      floorName: "",
      lineName: "",
      shopTextbutton: "مشاهده اطلاعات فروشگاه",
      tabsPop: null,
      setValue: [],
      idFloor: null,
      idLine: null,
      editShopId: null,
      tab2: 0,
      tab: 0,
      dtUrl: null,
      errors: {},
      domainId: null,
      picture: "",
      loading: false,
      renderKey: 0,
      editShopValue: [],
      qr_id: "",
    };
  },

  methods: {
    setFloor(e) {
      if (e === "submit") {
        if (this.floorName.length > 3) {
          this.floorNameHok?.floors.push({
            name: this.floorName,
            id: this.floorNameHok?.floors.length + 1,
            items: [],
            shops: [],
            image: this.picture ?? null,
          });
          this.tab = this.floorNameHok?.floors.length - 1;
          this.floorName = "";
          this.addFloors = true;
          this.addShop = false;
          this.idFloor = this.floorNameHok?.floors.length;
          this.picture = "";
          this.$toast.success("طبقه فروشگاه شما با موفقیت ساخته شد");
        } else {
          this.$toast.error(
            "مقدار فیلد نمی‌تواند خالی یا کمتر از ۴ کاراکتر باشد",
          );
          setTimeout(() => (this.addShop = true), 2000);
        }
      }
    },

    setLine(e) {
      if (e === "submit") {
        if (this.lineName.length < 3) {
          this.$toast.error("فیلد لاین نمی‌تواند کمتر از ۳ کاراکتر داشته باشد");
          setTimeout(() => (this.addLineName = true), 2000);
          return;
        }

        const floorIndex = this.floorNameHok?.floors.findIndex(
          (floor) => floor.id === this.idFloor,
        );
        if (floorIndex === -1) {
          this.$toast.error("طبقه انتخاب‌شده یافت نشد");
          return;
        }

        const newLine = {
          id: this.floorNameHok?.floors[floorIndex].items.length + 1,
          name: this.lineName,
          image: this.picture || null,
          shops: [],
        };

        this.floorNameHok?.floors[floorIndex].items.push(newLine);
        this.$nextTick(() => {
          this.tab2 = this.floorNameHok?.floors[floorIndex].items.length - 1; // انتخاب لاین جدید
          this.renderKey += 1; // فورس رندر
          this.lineName = "";
          this.picture = "";
          this.addLineName = false;
          this.$toast.success("لاین طبقه شما با موفقیت ساخته شد");
        });
      }
    },

    async addShopLine(e) {
      const findeShops = this.floorNameHok.shops.find(
        (shop) => shop.setting.name == this.dtUrl,
      );
      if (findeShops) {
        this.$toast.error("شما نمیتوانید کیوآر تکراری وارد کنید");
        return;
      }
      this.addShops = false;
      const data = await this.getProduct(this.dtUrl);
      if (!data) return;

      const imageUrl =
        data.data.type.toLowerCase() === "visitcard"
          ? data.data?.data?.data?.photo?.headBackground.length > 0
            ? [
                {
                  url: data.data?.data?.data?.photo?.headBackground,
                  description: "",
                  id: Math.ceil(Math.random() * 10000),
                  link: "qrland.ir",
                  name: "6",
                  title: "سامانه بزرگ کیوآر لند",
                },
              ]
            : data.data?.data?.data?.photo?.gallery?.[0]?.images?.map(
                (item) => item,
              )
          : data.data?.data?.data?.banner?.gallery?.[0]?.images.map(
              (item) => item,
            );

      const newShop = {
        qr_id: data?.data.id || "",
        mobile: data?.phone || "",
        title: data.data?.title || "",
        alias: e.pay?.button?.title,
        subtitle: data.data?.data?.data?.subOrgan || "",
        images: imageUrl || [],
        use_type: e.pay?.use_type,
        rent: e.pay?.rent?.rent || 0,
        rend_due_days: e.pay?.rent?.rend_due_days || 0,
        late_rent_percentage: e.pay?.rent?.late_rent_percentage || 0,
        charge: e.pay?.charge?.charge || 0,
        charge_due_days: e.pay?.charge?.charge_due_days || 0,
        late_charge_percentage: e.pay?.charge?.late_charge_percentage || 0,
        late_charge_days: e.pay.charge.late_charge_days || 0,
        late_rent_days: e.pay.rent.late_rent_days || 0,

        setting: {
          floor: this.idFloor || 0,
          line: this.idLine || 0,
          name: this.dtUrl,
          qr_type: data.data.type,
          organizationName: data.data?.data?.data?.organizationName,
        },
        type: e?.pay?.type.value,
      };
      if (await this.updateShop(newShop)) {
        const floorIndex = this.floorNameHok.floors.findIndex(
          (floor) => floor.id === this.idFloor,
        );
        if (floorIndex === -1) return;

        const floor = this.floorNameHok.floors[floorIndex];
        const shopData = {
          url: this.dtUrl,
          id:
            this.floorNameHok.floors[this.idFloor ? this.idFloor - 1 : 0]
              ?.items[this.idLine ? this.idLine - 1 : 0]?.shops?.length + 1,
          qr_id: data.data.id,
          data: data.data.data.data ?? {},
          phone: data.phone,
          type: data.data.type,
          button: e.pay.button.title,
        };

        if (!this.idLine) {
          shopData.id =
            this.floorNameHok.floors[this.idFloor ? this.idFloor - 1 : 0]?.shops
              .length + 1;
          floor.shops = floor.shops || [];
          floor.shops.push(shopData);
          this.$toast.success("فروشگاه شما با موفقیت به طبقه اضافه شد");
        } else {
          const line = floor.items.find((line) => line.id === this.idLine);
          if (line) {
            line.shops = line.shops || [];
            line.shops.push(shopData);
            this.$toast.success("فروشگاه شما با موفقیت به لاین اضافه شد");
          }
        }

        const imageUrl =
          data.data.type.toLowerCase() === "visitcard"
            ? data.data?.data?.data?.photo?.headBackground.length > 0
              ? [
                  {
                    url: data.data?.data?.data?.photo?.headBackground,
                    description: "",
                    id: Math.ceil(Math.random() * 10000),
                    link: "",
                    name: "",
                    title: "",
                  },
                ]
              : data.data?.data?.data?.photo?.gallery?.[0]?.images?.map(
                  (item) => item,
                )
            : data.data?.data?.data?.banner?.gallery?.[0]?.images.map(
                (item) => item,
              );

        this.floorNameHok.shops.push({
          qr_id: data.data.id || "",
          mobile: data.phone || "",
          title: data.data.title || "",
          alias: e.pay.button.title,
          subtitle: data.data?.data?.data?.subOrgan || "",
          images: imageUrl || [],
          use_type: e.pay.use_type,
          rent: e.pay?.rent?.rent || 0,
          rend_due_days: e.pay?.rent?.rend_due_days || 0,
          late_rent_percentage: e.pay?.rent?.late_rent_percentage || 0,
          charge: e.pay?.charge?.charge || 0,
          charge_due_days: e.pay?.charge?.charge_due_days || 0,
          late_charge_percentage: e.pay?.charge?.late_charge_percentage || 0,
          late_charge_days: e.pay.charge.late_charge_days || 0,
          late_rent_days: e.pay.rent.late_rent_days || 0,

          setting: {
            floor: this.idFloor || 0,
            line: this.idLine || 0,
            name: this.dtUrl,
            qr_type: data.data.type,
            organizationName: data.data?.data?.data?.organizationName,
          },
          type: e.pay.type.value,
        });

        this.$nextTick(() => {
          this.renderKey += 1;
          this.dtUrl = "";
        });
      } else {
        this.$toast.error("مشکلی پیش آمده است");
      }
    },
    editShopLine(e) {
      this.loading = true;
      this.editShop = false;
      try {
        const updatedShops = this.value.shops.map((item) => {
          if (item.qr_id === e.qr_id) {
            return {
              ...item,
              alias: e.pay.button.title,
              use_type: e.pay.use_type,
              rent: e.pay?.rent?.rent || null,
              rend_due_days: e.pay?.rent?.rend_due_days || null,
              late_rent_percentage: e.pay?.rent?.late_rent_percentage || null,
              charge: e.pay?.charge?.charge || null,
              charge_due_days: e.pay?.charge?.charge_due_days || null,
              late_charge_percentage:
                e.pay?.charge?.late_charge_percentage || null,
              late_charge_days: e.pay?.charge?.late_charge_days || null,
              late_rent_days: e.pay?.rent?.late_rent_days || null,
              type: e.pay.type.value,
            };
          } else {
            return item;
          }
        });
        localStorage.setItem("renr", JSON.stringify(e));
        this.floorNameHok.shops = [...updatedShops];
        this.$toast.success("با موفقیت انجام شد");
      } catch (errror) {
        this.$toast.error("مشکلی پیش آمده دوباره امتحان کنید");
      } finally {
        this.loading = false;
      }
    },
    addShopLineWithModal(e) {
      if (e === "close") {
        this.dtUrl = "";
      }
    },

    async getProduct(url) {
      try {
        this.loading = true;
        const response = await this.$api.post(
          `${this.$qrApi}/v1/commercial/find`,
          { domain: "qrland.in", identifier: url },
        );
        return { data: response.data.data.qr, phone: response.data.data.phone };
      } catch (error) {
        this.$toast.error("مشکلی پیش آمده است");
        return null;
      } finally {
        this.loading = false;
      }
    },

    // async deleteLine(floorId, lineId, name) {
    //   if (
    //     await this.$modal.yesNo(
    //       `آیا از حذف لاین - ${name} - خود اطمینان دارید؟`
    //     )
    //   ) {
    //     const floorIndex = this.floorNameHok.floors.findIndex(
    //       (item) => item.id === floorId
    //     );
    //     if (floorIndex !== -1) {
    //       const floor = this.floorNameHok.floors[floorIndex];
    //       floor.items = floor.items.filter((item) => item.id !== lineId);
    //       this.floorNameHok.shops = this.floorNameHok.shops.filter(
    //         (item) =>
    //           item.setting.floor != floorId || item.setting.line !== lineId
    //       );
    //       this.$nextTick(() => {
    //         if (floor.items.length === 0) this.tab2 = 0;
    //         this.renderKey += 1;
    //         this.$toast.success("لاین شما با موفقیت حذف شد");
    //       });
    //     }
    //   }
    // },

    // async deleteFloor(floorId, name) {
    //   if (
    //     await this.$modal.yesNo(
    //       `آیا از حذف طبقه - ${name} - خود اطمینان دارید؟`
    //     )
    //   ) {
    //     this.floorNameHok.floors = this.floorNameHok.floors.filter(
    //       (item) => item.id !== floorId
    //     );
    //     this.floorNameHok.shops = this.floorNameHok.shops.filter(
    //       (item) => item.setting.floor !== floorId
    //     );
    //     this.$nextTick(() => {
    //       this.renderKey += 1;
    //       this.$toast.success("طبقه شما با موفقیت حذف شد");
    //     });
    //   }
    // },

    // async deleteShop(floorId, lineId, shopId, name, qr_id) {
    //   if (
    //     await this.$modal.yesNo(
    //       `آیا از حذف فروشگاه - ${name} - خود اطمینان دارید؟`
    //     )
    //   ) {
    //     const floor = this.floorNameHok.floors.find(
    //       (item) => item.id === floorId
    //     );
    //     const line = floor.items.find((item) => item.id === lineId);
    //     if (line) {
    //       line.shops = line.shops.filter((shop) => shop.id !== shopId);
    //       this.floorNameHok.shops = this.floorNameHok.shops.filter(
    //         (item) =>
    //           item.qr_id !== qr_id ||
    //           item.setting.floor !== floorId ||
    //           item.setting.line !== lineId
    //       );

    //       // console.log("shps", floorId, "-", lineId);

    //       this.$nextTick(() => {
    //         this.renderKey += 1;
    //         this.$toast.success("فروشگاه شما با موفقیت حذف شد");
    //       });
    //     }
    //   }
    // },

    // async deleteShopFromFloor(floorId, shopId, name, qr_id) {
    //   if (
    //     await this.$modal.yesNo(
    //       `آیا از حذف فروشگاه - ${name} - خود اطمینان دارید؟`
    //     )
    //   ) {
    //     const floor = this.floorNameHok.floors.find(
    //       (item) => item.id === floorId
    //     );
    //     floor.shops = floor.shops.filter((shop) => shop.id !== shopId);

    //     this.floorNameHok.shops = this.floorNameHok.shops.filter(
    //       (item) => item.qr_id !== qr_id || item.setting.floor !== floorId
    //     );
    //     this.$nextTick(() => {
    //       this.renderKey += 1;
    //       this.$toast.success("فروشگاه شما با موفقیت حذف شد");
    //     });
    //   }
    // },

    getDataAsValue(qr_id) {
      const data = this.floorNameHok.shops.find((shop) => shop.qr_id !== qr_id);

      return data;
      // منطق ویرایش فروشگاه (نیاز به تکمیل بر اساس نیاز)
    },

    findShop(e) {
      const find = this.floorNameHok.find((item) => item.qr_id === e);
      return find;
    },

    async updateShop(e) {
      const shops = [...this.floorNameHok.shops, e];
      this.loading = true;
      const data = {
        domain:
          this.domainName?.length > 0 ? `${this.domainName}/` : "qrland.in/",
        identifier:
          this.qrId?.length > 0 ? this.qrId : this.qrInfo.identifier || "",
        commercial: {
          commercial: {
            rent_sms: null,
            due_rent: null,
            charge_sms: null,
            due_charge: null,
          },
          stores: shops,
        },
      };
      // data.append("domain", `${this.domainName}/`);
      // data.append("identifier", this.qrId || "");
      // data.append(
      //   "commercial",
      //   JSON.stringify({
      //     commercial: {
      //       rent_sms: null,
      //       due_rent: null,
      //       charge_sms: null,
      //       due_charge: null,
      //     },
      //     stores: shops,
      //   })
      // );
      try {
        await this.$api.post("/v1/commercial/qr/update", JSON.stringify(data));
        this.loading = false;
        return true;
      } catch (err) {
        this.loading = false;
        return false;
      }
    },
    async deleteShops(e) {
      const shops = [...e];

      this.loading = true;
      // const data = new FormData();
      // data.append("domain", `${this.domainName}/`);
      // data.append("identifier", this.qrId || "");
      // data.append(
      //   "commercial",
      //   JSON.stringify({
      //     commercial: {
      //       rent_sms: null,
      //       due_rent: null,
      //       charge_sms: null,
      //       due_charge: null,
      //     },
      //     stores: shops,
      //   })
      // );
      const data = {
        domain:
          this.domainName?.length > 0 ? `${this.domainName}/` : "qrland.in/",
        identifier:
          this.qrId?.length > 0 ? this.qrId : this.qrInfo.identifier || "",
        commercial: {
          commercial: {
            rent_sms: null,
            due_rent: null,
            charge_sms: null,
            due_charge: null,
          },
          stores: shops,
        },
      };
      try {
        await this.$api.post("/v1/commercial/qr/update", JSON.stringify(data));
        this.loading = false;
        return true;
      } catch (err) {
        this.loading = false;
        return false;
      }
    },

    async deleteEntityFromLocalAndServer(
      filterFunc,
      localUpdateCallback,
      successMessage,
      errorMessage = "مشکلی پیش آمد، دوباره تلاش کنید",
    ) {
      try {
        const confirmed = await this.$modal.yesNo("آیا مطمئن هستید؟");
        if (!confirmed) return;

        // 1. فیلتر کردن آرایه جدید بر اساس filterFunc (مثلا حذف یک آیتم)
        const newShops = this.floorNameHok.shops.filter(filterFunc);

        // 2. آپدیت سرور
        const updated = await this.deleteShops(newShops);

        if (updated) {
          // 3. آپدیت محلی با کال بک
          localUpdateCallback();

          this.$nextTick(() => {
            this.renderKey += 1;
            this.$toast.success(successMessage);
          });
        } else {
          this.$toast.error(errorMessage);
        }
      } catch (error) {
        this.$toast.error(errorMessage);
      }
    },
    async deleteShopFromFloor(floorId, shopId, name, qr_id) {
      await this.deleteEntityFromLocalAndServer(
        (item) => !(item.qr_id === qr_id && item.setting.floor === floorId),
        () => {
          const floor = this.floorNameHok.floors.find(
            (item) => item.id === floorId,
          );
          if (floor) {
            floor.shops = floor.shops.filter((shop) => shop.id !== shopId);
          }
          this.floorNameHok.shops = this.floorNameHok.shops.filter(
            (item) => !(item.qr_id === qr_id && item.setting.floor === floorId),
          );
        },
        "فروشگاه شما با موفقیت حذف شد",
      );
    },
    async deleteShop(floorId, lineId, shopId, name, qr_id) {
      await this.deleteEntityFromLocalAndServer(
        (item) =>
          !(
            item.qr_id === qr_id &&
            item.setting.floor === floorId &&
            item.setting.line === lineId
          ),
        () => {
          const floor = this.floorNameHok.floors.find(
            (item) => item.id === floorId,
          );
          const line = floor?.items.find((item) => item.id === lineId);
          if (line) {
            line.shops = line.shops.filter((shop) => shop.id !== shopId);
          }
          this.floorNameHok.shops = this.floorNameHok.shops.filter(
            (item) =>
              !(
                item.qr_id === qr_id &&
                item.setting.floor === floorId &&
                item.setting.line === lineId
              ),
          );
        },
        "فروشگاه شما با موفقیت حذف شد",
      );
    },
    async deleteLine(floorId, lineId, name) {
      try {
        const confirmed = await this.$modal.yesNo(
          `آیا از حذف لاین - ${name} - خود اطمینان دارید؟`,
        );
        if (!confirmed) return;

        const floorIndex = this.floorNameHok.floors.findIndex(
          (item) => item.id === floorId,
        );
        if (floorIndex === -1) {
          this.$toast.error("طبقه انتخاب‌شده یافت نشد");
          return;
        }

        // حذف همه فروشگاه‌های مرتبط با این لاین
        const newShops = this.floorNameHok.shops.filter(
          (item) =>
            !(item.setting.floor === floorId && item.setting.line === lineId),
        );
        // const updated = false;
        const updated = await this.deleteShops(newShops);

        if (updated) {
          const floor = this.floorNameHok.floors[floorIndex];
          floor.items = floor.items.filter((item) => item.id !== lineId);
          this.floorNameHok.shops = newShops;

          this.$nextTick(() => {
            if (floor.items.length === 0) this.tab2 = 0;
            this.renderKey += 1;
            this.$toast.success("لاین شما با موفقیت حذف شد");
          });
        } else {
          this.$toast.error("مشکلی در حذف لاین رخ داده است");
        }
      } catch (error) {
        this.$toast.error("خطا در حذف لاین، دوباره تلاش کنید");
      }
    },
    async deleteFloor(floorId, name) {
      try {
        const confirmed = await this.$modal.yesNo(
          `آیا از حذف طبقه - ${name} - خود اطمینان دارید؟`,
        );
        if (!confirmed) return;

        const newShops = this.floorNameHok.shops.filter(
          (item) => item.setting.floor !== floorId,
        );
        const updated = await this.deleteShops(newShops);
        // const updated = false;

        if (updated) {
          this.floorNameHok.floors = this.floorNameHok.floors.filter(
            (item) => item.id !== floorId,
          );
          this.floorNameHok.shops = newShops;

          this.$nextTick(() => {
            this.renderKey += 1;
            this.$toast.success("طبقه شما با موفقیت حذف شد");
          });
        } else {
          this.$toast.error("مشکلی در حذف طبقه رخ داده است");
        }
      } catch (error) {
        this.$toast.error("خطا در حذف طبقه، دوباره تلاش کنید");
      }
    },
  },

  computed: {
    ...mapState("local", ["qrInfo"]),
    floorNameHok: {
      get() {
        return this?.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  mounted() {
    Bus.$on("qr_idd", (qrId) => {
      // console.log("dddd->", qrId);
      this.qr_id = qrId;
    });
  },

  watch: {
    floorNameHok: {
      deep: true,
      handler(val) {
        localStorage.setItem("json", JSON.stringify(val));
      },
    },
    editShop(val) {
      if (!val) {
        this.editShopId = null;
        this.editShopValue = [];
        this.dtUrl = null;
      } else {
        this.editShopValue = this.value.shops.find(
          (item) => item.qr_id === this.editShopId,
        );
      }
    },
    tab(val) {
      this.tab2 = 0;
      this.renderKey += 1;
    },
    tab2(val) {
      const currentFloor = this.floorNameHok.floors[this.tab];
      if (currentFloor && val >= currentFloor.items.length) {
        this.tab2 = 0;
        this.renderKey += 1;
      }
    },

    // "floorNameHok.shops": {
    //   deep: true,
    //   handler(val, oldVal) {
    //     this.updateShop();
    //   },
    // },
  },
};
</script>
